//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    SIM_PROVIDER_ACCOUNT_CREATE_REQUEST,
    SIM_PROVIDER_ACCOUNT_EDIT_REQUEST,
    SIM_PROVIDER_ACCOUNT_GET_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    simProviderAccountCreateResult,
    simProviderAccountEditResult,
    simProviderAccountGetResult,
} from 'Redux/actions';

function* getSimProviderAccount({ payload }) {
    try {
        let QUERY = `
            query getSimProviderAccount ($id: Int!) {
                result: getSimProviderAccount (id: $id) {
                    id
                    name
                    simProviderId
                    simProvider {
                        id
                        name
                    }
                    simType
                    username
                    password
                    api
                    apn
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(simProviderAccountGetResult(data.result))

    } catch (exc) {
        yield put(simProviderAccountGetResult())
        ExceptionManager(exc, 'Modules/simProviderAccounts/views/.components/createEditSimProviderAccount/redux/saga', 'getSimProviderAccount');
    }
}

function* createSimProviderAccount({ payload }) {
    try {
        let QUERY = `
            mutation createSimProviderAccount ($name: String!, $simProviderId: Int!, $simType: String!, $username: String, $password: String, $api: Boolean, $apn: String) {
                result: createSimProviderAccount (name: $name, simProviderId: $simProviderId, simType: $simType, username: $username, password: $password, api: $api, apn: $apn) {
                    id
                    name
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(simProviderAccountCreateResult(data?.result))
        } else yield put(simProviderAccountCreateResult())

    } catch (exc) {
        yield put(simProviderAccountCreateResult({ error: exc.error }))
        ExceptionManager(exc, 'Modules/simProviderAccounts/views/.components/createEditSimProviderAccount/redux/saga', 'createSimProviderAccount');
    }
}

function* updateSimProviderAccount({ payload }) {
    try {
        let QUERY = `
            mutation updateSimProviderAccount ($id: Int!, $name: String!, $simProviderId: Int!, $simType: String!, $username: String, $password: String, $api: Boolean, $apn: String) {
                result: updateSimProviderAccount (id: $id, name: $name, simProviderId: $simProviderId, simType: $simType, username: $username, password: $password, api: $api, apn: $apn) {
                    id
                    name
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        yield put(simProviderAccountEditResult(data?.result));

    } catch (exc) {
        yield put(simProviderAccountEditResult({ error: exc.error }))
        ExceptionManager(exc, 'Modules/simProviderAccounts/views/.components/createEditSimProviderAccount/redux/saga', 'updateSimProviderAccount');
    }
}

function* watchSimProviderAccountsRequests() {
    yield takeEvery(SIM_PROVIDER_ACCOUNT_GET_REQUEST, getSimProviderAccount);
    yield takeEvery(SIM_PROVIDER_ACCOUNT_CREATE_REQUEST, createSimProviderAccount);
    yield takeEvery(SIM_PROVIDER_ACCOUNT_EDIT_REQUEST, updateSimProviderAccount);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchSimProviderAccountsRequests)
    ]);
}